<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_medicaldocument`)" :subHeader="$t('headers.general.medicaldocuments')" class="medical-document-form">
		<div slot="buttons">
			<button @click="showView('report')" :class="btnClass('report')">{{ $t('buttons.general.report') }}</button>
			<button @click="showView('attachments')" :class="btnClass('attachments')">{{ $t('buttons.general.attachment') }}</button>
		</div>
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<div class="report" v-show="isView('report')">
				<input-text v-model="model.data.name" name="document_name" :placeholder="$t('labels.general.name')" rules="required"/>
				<input-text v-model="model.data.responsible" name="document_responsible" :placeholder="$t('labels.general.responsible')" rules="required"/>
				<input-select v-model="model.data.category_id" :options="options" name="document_categories_id" :placeholder="$t('labels.general.category')" rules="required"/>
				<input-textarea v-model="model.data.description" name="document_description" :placeholder="$t('labels.general.description')"/>
			</div>
			<div class="attachments" v-show="isView('attachments')">
				<file-upload :user_uid="user_uid" :watch_id="watch_id" :document_id="document_id" v-model="model.data.file" :active="isView('attachments')" @uploading="onFileUploading"/>
			</div>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<label class="btn btn-icon-text btn-attach" for="file" v-if="isView('attachments')">
					<svgicon name="attachment" :fill="false"/>
					<spinner v-if="form.uploading" size="small"/>
					<span v-else>{{ $t('buttons.general.attach') }}</span>
				</label>
				<button-submit-icon-text :loading="form.loading || form.uploading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import MedicalDocument from '@/classes/MedicalDocument'
import FileUpload from './MedicalDocumentFileUpload'
export default {
	components: {
		FileUpload
	},
	props: [
		'user_uid',
		'watch_id',
		'document_id',
		'params'
	],
	data () {
		return {
			name: 'watch medicaldocuments form',
			categories: [],
			model: new ApiObject(),
			form: {
				loading: false,
				uploading: false,
				error: ''
			},
			view: 'report'
		}
	},
	computed: {
		options () {
			const options = []
			this.categories.forEach(category => {
				options.push({
					value: category.id,
					text: this.$t('categories.report.'+category.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase())
				})
			})
			return options
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addDocument()
					break
				case 'edit':
					this.editDocument()
					break
				default:
					this.$log.warn(this.name, 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getDocument () {
			this.model.loading = true
			this.$api.medicaldocuments.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info(this.name, 'medicaldocuments.get OK', response)()
					this.model.data = new MedicalDocument(response.body)
				}).catch(error => {
					this.$log.error(this.name, 'medicaldocuments.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addDocument () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.medicaldocuments.add(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info(this.name, 'medicaldocuments.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'medicaldocuments.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editDocument () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.medicaldocuments.edit(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info(this.name, 'medicaldocuments.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'medicaldocuments.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		getCategories () {
			this.$api.medicaldocuments.categories.getAll(this)
				.then(response => {
					this.$log.info(this.name, 'medicaldocuments.getCategories OK', response)()
					this.categories = response.body
				}).catch(error => {
					this.$log.error(this.name, 'medicaldocuments.getCategories ERROR', error)()
				})
		},
		serializeModel () {
			return {
				id: this.model.data.id,
				name: this.model.data.name,
				file: this.model.data.file,
				responsible: this.model.data.responsible,
				description: this.model.data.description,
				categories_id: this.model.data.category_id
			}
		},
		showView (view) {
			this.view = view
		},
		isView (view) {
			return this.view === view
		},
		btnClass (view) {
			return { active: this.isView(view) }
		},
		onFileUploading (value) {
			this.form.uploading = value
		}
	},
	beforeCreate () {
		this.$title('Medical Document Form')
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = new MedicalDocument()
				this.model.data.category_id = this.params.category_id
				break
			case 'edit':
				this.getDocument()
				break
			default:
				this.$log.warn(this.name, 'action not set')()
		}
		this.getCategories()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/medicaldocuments/MedicalDocumentForm.vue